import { zipcodeFormatter } from '@asn/formatters';

import { AfterViewInit, Component, input, ViewEncapsulation, inject } from '@angular/core';
import { NgControl, FormsModule } from '@angular/forms';
import { NgTemplateOutlet } from '@angular/common';

import { ApContentService } from '@ap/content';
import { ApInputConstraintService } from '@ap/input/constraint';
import { AbstractInputComponent, ApAutocompleteFilterService, ApAutocompleteModule } from '@ap/input';
import { ApZipcodeValidator } from '@ap/input/validators';
import { ApSuggestionComponent } from '@ap/input/suggestion';
import { ApFormErrorsComponent } from '@ap/form/errors';
import { ApIconComponent } from '@ap/icon';

import content from './zipcode-input.content.json';

@Component({
    selector: 'ap-zipcode-input',
    templateUrl: '../../../src/lib/input.component.html',
    styleUrls: ['../../../src/lib/input.component.scss'],
    encapsulation: ViewEncapsulation.Emulated,
    imports: [FormsModule, ApIconComponent, ApSuggestionComponent, ApFormErrorsComponent, ApAutocompleteModule, NgTemplateOutlet],
    providers: [ApInputConstraintService]
})
export class ApZipcodeInputComponent extends AbstractInputComponent implements AfterViewInit {
    protected control = inject(NgControl, { self: true, optional: true });
    protected readonly inputConstraintService = inject(ApInputConstraintService);
    protected readonly contentService = inject(ApContentService);
    protected readonly filterService = inject(ApAutocompleteFilterService);

    /**
     * Maxlength of a zipcode is 7
     */
    protected readonly maxlength = input<number>(7);

    /**
     * Characters that are stripped
     */
    protected readonly stripPattern = input<RegExp>(/[^0-9a-z\s]/gi);

    constructor() {
        super();
        this.setDefaultContent(content, 'zipcode-input');
    }

    /**
     * After init bind the control validation
     */
    public ngAfterViewInit(): void {
        const control = this.control?.control;
        if (control) {
            control.addValidators([ApZipcodeValidator.validate]);
            control.updateValueAndValidity();
        }
    }

    /**
     * Format display value as zipcode.
     * Called on blur of input
     */
    protected formatValueDisplay(value: string): string {
        return zipcodeFormatter.formatDisplay(value);
    }

    /**
     * Format value as zipcode.
     * Called on blur of input
     */
    protected formatValue(value: string): string {
        return zipcodeFormatter.format(value);
    }
}
